'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const Snackbar = require('common/util/snackbar');
const Dialog = require('common/util/dialog');
const ReadMore = require('common/ui/view/behavior/readmore');
const ModalView = require('common/ui/view/modal/index');
const CommentsCounterView = require('communication/ui/comment/view/counter');
const TasksCounterView = require('communication/ui/view/task/counter');
const DiagramActionWorkRelationService = require('balus/app/service/actionwork/diagram/relation');
const DiagramActionWorkDeleteService = require('balus/app/service/actionwork/diagram/delete');
const DiagramActionWorkRepository = require('balus/infra/repository/actionwork/diagram');
const Template = require('balus/ui/template/body/process/content/diagram-item.hbs');
const RelationView = require('balus/ui/view/body/process/content/relation');

const ItemView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: Template,
    ui: {
        relationButton: '.relation',
        deleteButton: '.delete',
        addComment: '.add-comment',
        addTask: '.add-task',
    },
    regions: {
        commentsCounter: '.comments-counter',
        tasksCounter: '.tasks-counter',
    },
    events: {
        'click .list-item-header-title .push-state': 'open',
        'click @ui.relationButton': 'updateRelation',
        'click @ui.deleteButton': 'delete',
        'click @ui.addComment': 'addComment',
        'click @ui.addTask': 'addTask',
    },
    modelEvents: {
        'change': 'render'
    },
    templateContext: function() {
        const context = this.getOption('context');
        const user = context.getUser();
        const group = context.getGroup();
        const work = this.model.getWork();
        let j = work.getTarget().toJSON();
        j.url = work.getTarget().path();
        j.input = this.model.isInput();
        j.output = this.model.isOutput();
        j.isMember = group.isMember(user ? user.id : null);
        return j;
    },

    open: function () {
        // アクション操作イベントをトラッキングするならば、ここに仕込む
    },

    updateRelation: function() {
        const modal = new ModalView({
            model: this.model,
            title: i18n.t('balus_template_body_process:modal.relation.title', {
                name: this.model.getAction().getName(),
                interpolation: { escapeValue: false }
            }),
            bodyView: new RelationView({model: this.model}),
            saveButtonEnable: true,
            onChildviewSave: function() {
                const relation = this.getChildView('body').getRelation();
                this.disableButtons();
                (new DiagramActionWorkRelationService(this.model, relation))
                    .update()
                    .then(() => {
                        this.hide();
                    })
                    .catch(() => {
                        this.enableButtons();
                    });
            }
        });
        modal.show();
    },

    delete: function() {
        const project = this.getOption('project');
        const actionWork = this.model;
        const diagramJSON = actionWork.getWork().getTarget().toJSON();

        Dialog.confirm({
            text: i18n.t('balus_view_body_process:content.diagram.dialog.deleteConfirm', {name: diagramJSON.name}),
            okCallback: () => {
                (new DiagramActionWorkDeleteService(
                    project, actionWork))
                    .delete()
                    .then(() => {
                        this.trigger('remove:actionWork', actionWork);
                        Snackbar.success(
                            i18n.t('balus_view_body_process:content.diagram.feedback.delete', {name: diagramJSON.name})
                        );
                    });
            }
        })
    },

    onRender: function() {
        const context = this.getOption('context');
        const project = context.getProject();
        const work = this.model.getWork();
        const model = work.getTarget();

        this.showChildView('commentsCounter', new CommentsCounterView({
            icon: 'fa fa-comments-o',
            project: project,
            key: model.key,
            hasComment: model.hasComment(),
        }));

        this.showChildView('tasksCounter', new TasksCounterView({
            icon: 'fa fa-check-square',
            project: project,
            key: model.key,
            hasTask: model.hasTask(),
        }));

        return this;
    },

    addComment: function() {
        const model = this.model.getWork().getTarget();
        this.trigger('add:comment', model);
    },

    addTask: function() {
        const model = this.model.getWork().getTarget();
        this.trigger('add:task', model);
    }
});

module.exports = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list',
    childView: ItemView,
    childViewOptions: function() {
        return {
            context: this.getOption('context'),
            project: this.model.getProject()
        }
    },
    childViewTriggers: {
        'add:comment': 'model:add:comment',
        'add:task': 'model:add:task'
    },
    behaviors: {
        ReadMore: {
            behaviorClass: ReadMore,
            showReadMore: function() {
                return DiagramActionWorkRepository.find(this.model.getProject())
                    .hasNextActionWorksByAction(this.model);
            },
            onReadMore: function() {
                return DiagramActionWorkRepository.find(this.model.getProject())
                    .fetchActionWorksByAction(this.model, 5);
            }
        }
    },

    onChildviewRemoveActionWork: function(actionWork) {
        this.collection.remove(actionWork);
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/content/diagram-work.js